<template>
  <div class="link-selector">
    <a v-if="fullPath" href="javascript:void(0)" :title="fullPath.pathText" class="link-selector__link">
      <el-tag :closable="!disabled" @close="clearLink" @click="handleEdit">
        <div class="link-selector__tag-content">{{ fullPath.pathText }}</div>
      </el-tag>
    </a>
    <el-cascader v-else v-model="link_types" :options="options" :props="props" :show-all-levels="false"
      :disabled="disabled" placeholder="请选择跳转链接" size="mini" @change="handleCascaderChange" />
    <en-shop-picker :show.sync="show_shop_picker" :buyer-domain="$$Domain['buyer_pc']" :request="$$Request" :limit="1"
      @confirm="handleShopPickerConfirm" />
    <en-goods-picker :show.sync="show_goods_picker" :type="$$DecorType" :limit="1" @confirm="handleGoodsPickerConfirm"
      @close="show_goods_picker = false" />
    <en-page-picker :show.sync="show_page_picker" :request="$$Request" :domain="$$Domain" :limit="1" type="decor"
      :page-type="platformType" @confirm="handlePagePickerConfirm" />
    <MiniProgramPicker :minProgramFormObj="minProgramFormObj" :min_program_type_num="min_program_type_num"  :show.sync="show_mini_program_picker"
      @confirm="handleMinProgramConfirm" @close="show_mini_program_picker = false" />
    <en-point-promotion-picker
      type="luck-draw"
      :show.sync="show_luck_draw_picker"
      :limit="1"
      @confirm="handleLuckDrawConfirm"
      @close="show_luck_draw_picker = false"
    />
    <en-point-promotion-picker
      type="point-vote"
      :show.sync="show_point_vote_picker"
      :limit="1"
      @confirm="handlePointVoteConfirm"
      @close="show_point_vote_picker = false"
    />
    <en-point-promotion-picker
      type="sign-in"
      :show.sync="show_point_sign_in_picker"
      :limit="1"
      @confirm="handleSignInConfirm"
      @close="show_point_sign_in_picker = false"
    />
    <el-dialog
      title="公众号推文"
      :visible.sync="show_official_accounts_picker"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="25%"
    >
      <el-form
        :model="officialAccountsForm"
        :rules="officialAccountsRules"
        ref="officialAccountsFormRef"
        label-width="80px"
        size="normal"
      >
        <el-form-item label="" prop="type">
          <el-radio-group v-model="officialAccountsForm.type">
            <el-radio label="1">相同主体公众号</el-radio>
            <el-radio label="2">不同主体公众号</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="链接" prop="url" style="margin-top: 20px">
          <el-input v-model="officialAccountsForm.url" placeholder="请输入公众号链接" size="normal" clearable></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="show_official_accounts_picker = false">取 消</el-button>
        <el-button type="primary" @click="handleOfficialAccountsConfirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as Rules from '@/utils/rules'
import * as API_Shop from '@/api/shop'
import * as API_Pages from '@/api/pages'
import { clientType, platformType } from '@/utils/decor-types'

export default {
  name: 'LinkSelector',
  props: {
    value: {
      type: [Object, String],
      required: true
    },
    // 是否禁用
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      minProgramFormObj: {},
      min_program_type_num: '1',
      link: '',
      link_types: '',
      props: { expandTrigger: 'hover' },
      shopInfo: '',
      show_shop_picker: false,
      show_goods_picker: false,
      show_page_picker: false,
      show_mini_program_picker: false,
      show_luck_draw_picker: false,
      show_point_vote_picker: false,
      show_point_sign_in_picker: false,
      miniPageItem: '',
      shopItem: '',
      platformType,
      show_official_accounts_picker: false,
      officialAccountsForm: {
        type: '1',
        url: ''
      },
      officialAccountsRules: {
        type: [{ required: true, message: '请选择公众号主体是否相同！', trigger: 'change' }],
        url: [{ required: true, message: '请填写公众号链接！', trigger: 'blur' }]
      }
    }
  },
  watch: {
    value: {
      immediate: true,
      handler: 'defaultValueChange'
    }
  },
  model: { event: 'update', prop: 'value' },
  mounted() {
    this.shopItem = this.$$ShopInfo
  },
  computed: {
    options() {
      if (this.$$Foundation.getURLSearchParma('activity_id')) {
        return [
          {
            label: '商品',
            value: '商品',
            children: [
              { label: '全部商品', value: 'goods' },
              { label: '部分商品', value: 'part-goods' },
              { label: '购物车', value: 'cart' },
              { label: '分类', value: 'category' }
            ]
          },
          {
            label: '营销工具',
            value: '营销工具',
            children: [
              { label: '优惠券', value: 'coupons' },
              { label: '限时抢购', value: 'seckill' }
              // { label: '拼团活动', value: 'assemble' }
            ]
          },
          {
            label: '其他',
            value: '其他',
            children: [
              { label: '自定义链接', value: 'custom' },
              { label: '小程序路径', value: 'mini-program', disabled: clientType === 'pc' }
            ]
          }
        ]
      }
      return [
        {
          label: '微页面',
          value: '微页面',
          children: [
            { label: '微页面', value: 'mini-page' },
            // { label: '店铺主页', value: 'shop-home' },
            { label: '个人中心', value: 'user-center' }
          ]
        },
        {
          label: '商品',
          value: '商品',
          disabled: Number(platformType) === 1,
          children: [
            { label: '全部商品', value: 'goods' },
            { label: '部分商品', value: 'part-goods' },
            { label: '购物车', value: 'cart' },
            { label: '分类', value: 'category' }
          ]
        },
        {
          label: '商品',
          value: '商品',
          disabled: Number(platformType) === 0,
          children: [
            { label: '商品详情', value: 'part-goods' },
          ]
        },
        {
          label: '营销工具',
          value: '营销工具',
          disabled: Number(platformType) === 1,
          children: [
            { label: '优惠券', value: 'coupons' },
            { label: '限时抢购', value: 'seckill' }
            // { label: '拼团活动', value: 'assemble' }
          ]
        },
        {
          label: '积分运营',
          value: '积分运营',
          disabled: Number(platformType) === 1,
          children: [
            // { label: '积分抽奖', value: 'point-luck-draw' },
            // { label: '积分投票入口', value: 'point-vote-entry' },
            // { label: '积分投票', value: 'point-vote' },
            { label: '积分签到', value: 'point-sign-in' }
          ]
        },
        {
          label: '其他',
          value: '其他',
          children: [
            { label: '商城小程序', value: 'shop-mini-program', disabled: Number(platformType) === 0 },
            { label: '自定义链接', value: 'custom' },
            { label: '小程序路径', value: 'mini-program', disabled: clientType === 'pc' },
            { label: '公众号推文', value: 'official-accounts', disabled: clientType === 'pc' }
          ].filter(item => !item.disabled)
        },
        {
          label: '缩放图片',
          value: '缩放图片',
          disabled: this.$$FormData.image_tpl !== 'single',
          children: [
            { label: '不需要，谢谢', value: 'noJump' },
            { label: '是的，我需要', value: 'yesJump' },
          ]
        },
      ].filter(item => !item.disabled)
    },
    fullPath() {
      if (!this.link || !this.link_types) return
      const option = this.options.filter(item => item.value === this.link_types[0])[0]
      const subOption = option.children.filter(item => item.value === this.link_types[1])[0]
      let path = [option, subOption]
      let pathText = `${option.label} | ${subOption.label}`
      const linkValue = this.link.value || ''
      if (subOption.value === 'mini-page') {
        pathText = `微页面 | ${this.miniPageItem['page_name'] || ''}`
      }
      if (subOption.value === 'shop-home' && this.shopItem) {
        pathText = `店铺首页 | ${this.shopItem['shop_name']}`
      }
      if (subOption.value === 'custom') {
        pathText = `外链 | ${this.link.value}`
      }
      if (subOption.value === 'mini-program') {
        pathText = `小程序路径 | ${JSON.stringify(this.link.value)}`
      }
      if (subOption.value === 'point-luck-draw') {
        const { name } = linkValue || {}
        pathText = `积分抽奖 | ${name}`
      }
      if (subOption.value === 'point-vote') {
        const { name } = linkValue || {}
        pathText = `积分投票 | ${name}`
      }
      if (subOption.value === 'point-sign-in') {
        const { name } = linkValue || {}
        pathText = `积分签到 | ${name}`
      }
      if (subOption.value === 'official-accounts') {
        const { type, url } = linkValue || {}
        pathText = `${type === '1' ? '相同主体公众号' : '不同主体公众号'} | ${url}`
      }
      return { path, pathText }
    }
  },
  methods: {
    /**
     * 选择器值发生改变
     * @param item
     */
    async handleCascaderChange(item) {
      const link_type = item[item.length - 1]
      let link = { type: link_type, value: '' }
      switch (link_type) {
        case 'custom':
          link.value = await this.inputCustomLink(); break
        case 'mini-program':
          this.show_mini_program_picker = true
          break
        // link.value = await this.inputMiniProgramLink(); break
        // link.value = await this.getMinProgramForm(); break
        case 'mini-page':
          this.show_page_picker = true
          link.value = undefined
          break
        case 'shop-home':
          link.value = await this.getShopLink(); break
        case 'user-center':
          link.value = `member`; break
        case 'part-goods':
          this.show_goods_picker = true
          link.value = undefined
          break
        case 'point-luck-draw':
          this.show_luck_draw_picker = true
          link.value = undefined
          break
        case 'point-vote':
          this.show_point_vote_picker = true
          link.value = undefined
          break
        case 'point-sign-in':
          this.show_point_sign_in_picker = true
          link.value = undefined
          break
        case 'official-accounts':
          this.show_official_accounts_picker = true
          link.value = undefined
          break
        default:
          link.value = `${link_type}`
      }
      if (link.value === undefined) return this.clearLink()
      this.link = link
      this.$emit('update', this.link)
    },
    /**
     * 清空值
     */
    clearLink() {
      this.$nextTick(() => {
        this.link = ''
        this.link_types = ''
      })
      this.$emit('update', '')
    },
    /**
     * 修改值
     */
    handleEdit() {
      if (!this.link || !this.link_types) return
      const option = this.options.filter(item => item.value === this.link_types[0])[0]
      const subOption = option.children.filter(item => item.value === this.link_types[1])[0]
      if (subOption.value === 'mini-program') {
        const { appid } = this.link.value || {}
        this.min_program_type_num = appid ? '2' : '1'
        this.minProgramFormObj = this.link.value
        this.show_mini_program_picker = true
      } else if (subOption.value === 'official-accounts') {
        const { type, url } = this.link.value || {}
        this.officialAccountsForm = { type, url }
        this.show_official_accounts_picker = true
      }
    },
    /**
     * 输入自定义链接
     * @returns {Promise<string>}
     */
    async inputCustomLink() {
      try {
        const res = await this.$prompt('请输入自定义链接', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPlaceholder: 'https://',
          inputPattern: Rules.url,
          inputErrorMessage: '链接格式不正确！'
        })
        return res.value
      } catch (e) {
        this.clearLink()
      }
    },
    /**
     * 输入小程序路径
     * @returns {Promise<string>}
     */
    async inputMiniProgramLink() {
      try {
        const res = await this.$prompt('请输入小程序路径', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPlaceholder: '请输入小程序路径'
        })
        return res.value
      } catch (e) {
        this.clearLink()
      }
    },

    /**
     * 默认值发生改变
     * @param newVal
     */
    async defaultValueChange(newVal) {
      this.link = newVal
      if (!newVal) this.link_types = ''
      let option = ''
      let subOption = ''
      for (let i = 0; i < this.options.length; i++) {
        option = this.options[i]
        if (option.value === newVal.type) break
        if (option.children && option.children.length) {
          subOption = option.children.filter(item => item.value === newVal.type)[0]
          if (subOption) break
          option = ''
          subOption = ''
        }
      }
      option && (this.link_types = [option.value])
      subOption && (this.link_types = [option.value, subOption.value])
      if (newVal && newVal.type === 'shop-home' && !this.shopItem) {
        this.shopItem = await API_Shop.getShopDetail(newVal.value)
      }
      if (newVal && newVal.type === 'mini-page' && !this.miniPageItem) {
        this.miniPageItem = await API_Pages.getPageDetail(newVal.value, false)
      }
    },
    /**
     * 获取店铺链接
     * @returns {Promise<string>}
     */
    async getShopLink() {
      if (this.$$ShopInfo) {
        return this.$$ShopInfo['shop_id']
      } else {
        this.show_shop_picker = true
        return undefined
      }
    },
    /**
     * 店铺选择器确认
     * @param items
     */
    handleShopPickerConfirm(items) {
      if (!items.length) return
      this.shopItem = items[0]
      this.link = {
        type: 'shop-home',
        value: items[0]['shop_id']
      }
      this.$emit('update', this.link)
    },
    /**
     * 商品选择器确认
     * @param items
     */
    handleGoodsPickerConfirm(items) {
      if (!items.length) return
      this.link = {
        type: 'part-goods',
        value: items[0]['goods_id']
      }
      this.$emit('update', this.link)
    },
    /**
     * 页面选择器确认
     * @param items
     */
    handlePagePickerConfirm(items) {
      if (!items.length) return
      this.miniPageItem = items[0]
      this.link = {
        type: 'mini-page',
        value: items[0].id
      }
      this.$emit('update', this.link)
    },
    /**
     * 小程序路径选择器确认
     * @param items
     */
    handleMinProgramConfirm(items) {
      // this.miniPageItem = items[0]
      this.link = {
        type: 'mini-program',
        value: items
      }
      this.$emit('update', this.link)
    },
    /**
     * 积分抽奖选择器确认
     * @param items
     */
    handleLuckDrawConfirm(items) {
      if (items && items[0]) {
        this.link = {
          type: 'point-luck-draw',
          value: { id: items[0].id, name: items[0].name }
        }
      } else {
        this.link = {
          type: 'point-luck-draw',
          value: { id: '' }
        }
      }
      this.$emit('update', this.link)
      this.$emit('changed', this.link)
    },
    /**
     * 积分投票选择器确认
     * @param items
     */
    handlePointVoteConfirm(items) {
      if (items && items[0]) {
        this.link = {
          type: 'point-vote',
          value: { id: items[0].id, name: items[0].name }
        }
      } else {
        this.link = {
          type: 'point-vote',
          value: { id: '' }
        }
      }
      this.$emit('update', this.link)
      this.$emit('changed', this.link)
    },
    /**
     * 积分签到选择器确认
     * @param items
     */
    handleSignInConfirm(items) {
      if (items && items[0]) {
        this.link = {
          type: 'point-sign-in',
          value: { id: items[0].id, name: items[0].name }
        }
      } else {
        this.link = {
          type: 'point-sign-in',
          value: { id: '' }
        }
      }
      this.$emit('update', this.link)
      this.$emit('changed', this.link)
    },
    handleOfficialAccountsConfirm() {
      this.$refs.officialAccountsFormRef.validate(valid => {
        if (!valid) return
        const { type, url } = this.officialAccountsForm
        this.link = {
          type: 'official-accounts',
          value: { type, url }
        }
        this.$emit('update', this.link)
        this.$emit('changed', this.link)
        this.show_official_accounts_picker = false
        this.officialAccountsForm = { type: '1', url: '' }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.link-selector {
  position: relative;
  display: flex;
  width: 100%;

  .link-selector__link {
    display: inline-block;
    width: 100%;
  }

  /deep/ {
    .el-tag {
      display: flex;
      align-items: center;
      position: relative;
      color: #155bd4;
      border-color: #155bd4;
      border-radius: 2px;
      width: 100%;
      height: 28px;
      box-sizing: border-box;
      margin-right: 5px;
      overflow: hidden;

      .el-tag__close {
        position: absolute;
        top: auto;
        right: 5px;
        color: #155bd4;

        &:hover {
          color: #ffffff;
          background-color: #155bd4;
        }
      }

      .link-selector__tag-content {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-right: 10px;
        max-width: 208px;
      }
    }

    .el-cascader {
      width: 100%;
    }
  }
}
</style>
